"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reduxForm = require("redux-form");
var _reactPhoneNumberInput = _interopRequireDefault(require("react-phone-number-input"));
var _libphonenumberJs = require("libphonenumber-js");
var _metadataMin = _interopRequireDefault(require("libphonenumber-js/metadata.min.json"));
var _APPhoneInputFlags = _interopRequireDefault(require("./APPhoneInputFlags"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _config = _interopRequireDefault(require("../../../config"));
require("react-phone-number-input/style.css");
require("./APPhoneInput.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClass = 'ap-phone-input';
var APPhoneInnerInput = /*#__PURE__*/function (_React$Component) {
  function APPhoneInnerInput(props) {
    var _this;
    _classCallCheck(this, APPhoneInnerInput);
    _this = _callSuper(this, APPhoneInnerInput, [props]);
    _defineProperty(_this, "onChange", function (value, phone) {
      var _this$props = _this.props,
        onChange = _this$props.input.onChange,
        name = _this$props.name;
      var _this$state = _this.state,
        countryPrefix = _this$state.countryPrefix,
        countryCode = _this$state.countryCode;
      var meta = {
        countryPrefix: countryPrefix,
        countryCode: countryCode,
        noPrefixPhone: phone && phone.replace("+".concat(countryPrefix), '')
      };
      onChange(value, phone, meta, name);
    });
    _defineProperty(_this, "onCountryChange", function (countryCode) {
      var countryPrefix = (0, _libphonenumberJs.getCountryCallingCode)(countryCode, _metadataMin["default"]);
      _this.setState({
        countryPrefix: countryPrefix,
        countryCode: countryCode
      });
    });
    _defineProperty(_this, "onFocus", function () {
      _this.setState({
        focused: true
      });
    });
    _defineProperty(_this, "onBlur", function () {
      _this.setState({
        focused: false
      });
    });
    _this.state = {
      phone: props.value,
      focused: false,
      countryPrefix: null,
      countryCode: null
    };
    return _this;
  }
  _inherits(APPhoneInnerInput, _React$Component);
  return _createClass(APPhoneInnerInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        customClass = _this$props2.customClass,
        classModifiers = _this$props2.classModifiers,
        info = _this$props2.info,
        label = _this$props2.label,
        rightLabelText = _this$props2.rightLabelText,
        _this$props2$meta = _this$props2.meta,
        error = _this$props2$meta.error,
        dirty = _this$props2$meta.dirty;
      var bemClasses = (0, _cssClassesHelper.getBEMClasses)([baseClass, customClass]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group ".concat(bemClasses('input-wrapper', classModifiers)),
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "ap--label ".concat(bemClasses('label', classModifiers))
      }, label), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(rightLabelText && bemClasses('input-with-right-label-container'), bemClasses('input-box'))
      }, /*#__PURE__*/_react["default"].createElement(_reactPhoneNumberInput["default"], {
        name: "telephone",
        value: this.state.phone,
        flagComponent: _APPhoneInputFlags["default"],
        international: false,
        displayInitialValueAsLocalNumber: true,
        country: this.props.country || _config["default"].global.phoneDefaultCountry,
        countries: _config["default"].global.phoneWhiteListCountries,
        placeholder: this.props.placeholder,
        onChange: this.onChange,
        onCountryChange: this.onCountryChange,
        metadata: _metadataMin["default"]
      }), info && /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-text-muted ".concat(bemClasses('info'))
      }, info), dirty && error && /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('error')
      }, error)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var phone = nextProps.value;
      if (phone) {
        var parsed = (0, _libphonenumberJs.parseNumber)(phone, _metadataMin["default"]);
        if (parsed.country) {
          var countryCode = parsed.country;
          var countryPrefix = countryCode && (0, _libphonenumberJs.getCountryCallingCode)(countryCode, _metadataMin["default"]);
          return {
            phone: phone,
            countryCode: countryCode,
            countryPrefix: countryPrefix
          };
        }
      }
      return {
        phone: phone
      };
    }
  }]);
}(_react["default"].Component);
APPhoneInnerInput.defaultProps = {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: '',
  country: '',
  onChange: function onChange() {}
};
APPhoneInnerInput.propTypes = {
  name: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].string,
  country: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  required: _propTypes["default"].bool
};
var APPhoneInput = function APPhoneInput(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: APPhoneInnerInput
  }, props));
};
APPhoneInput.defaultProps = {
  name: '',
  label: '',
  labelInInput: '',
  type: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  rows: 1
};
APPhoneInput.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  labelInInput: _propTypes["default"].string,
  type: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  placeholder: _propTypes["default"].string,
  info: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  autoFocus: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  rightLabelText: _propTypes["default"].string,
  rows: _propTypes["default"].number
};
var _default = exports["default"] = APPhoneInput;